import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const features = ['5 Tomos PDF completos (Hombro, Rodilla, Tobillo, Codo y Muñeca, Columna y Cadera)', 'Método Progresión Blindada en las 5 articulaciones', '5 Bonos estratégicos gratis', 'Acceso inmediato', 'Garantía de 7 días'];
function PlanCard() {
  return <article className="relative flex flex-col rounded-3xl border-2 border-accent bg-white p-6 shadow-[0_25px_60px_rgba(3,105,161,.18)] md:p-8" data-id="element-264" data-mp="f9zzcprmj4c4">
      <div className="flex items-start gap-2" data-id="element-265" data-mp="6a34g6en598m">
        <span className="text-3xl" data-id="element-266" data-mp="6dh6tenb1ig2">📚</span>
        <h3 className="text-xl font-extrabold leading-tight text-slate-900" data-id="element-267" data-mp="abyf41igoyz2">
          Combo Completo Rehabilitación de Lesiones
        </h3>
      </div>
      <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-268" data-mp="2r3q3z9hklunb">5 Tomos + 5 Bonos</p>

      <p className="my-6 rounded-xl border border-sky-100 bg-sky-50/70 p-4 text-sm leading-relaxed text-slate-600" data-id="element-269" data-mp="2v4a1wf9yx2ai">
        <b className="text-slate-900" data-id="element-270" data-mp="2fpfeai5vilqc">Ideal para:</b> Profesores de educación física, entrenadores
        personales, kinesiólogos y personas con lesiones que quieren un sistema completo, progresivo
        y listo para aplicar en casa o en el gimnasio.
      </p>

      <ul className="mb-6 space-y-2" data-id="element-271" data-mp="2klw4dhwmva62">
        {features.map(feature => <li key={feature} className="flex items-start gap-2 text-sm font-medium text-slate-700" data-id="element-272" data-mp="2yloogudnms52">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-273" data-mp="2to5azwos6je6" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6 text-center" data-id="element-274" data-mp="38bqazhqd02hv">
        <span className="mb-3 inline-block rounded-full bg-sky-100 px-3 py-1 text-xs font-extrabold text-primary" data-id="element-275" data-mp="33df3verg863c">
          AHORRÁS $40.000
        </span>
        <p className="mt-2 text-sm font-bold text-slate-400 line-through" data-id="element-276" data-mp="3hdhlr0zrazil">Antes: $60.000</p>
        <p className="mt-1 text-xs font-bold uppercase text-slate-500" data-id="element-277" data-mp="3cfg0qairsq4h">Hoy</p>
        <p className="text-5xl font-extrabold text-slate-900" data-id="element-278" data-mp="2a1i4m25itnbw">$19.990</p>
      </div>

      <Button href={purchaseUrls.base} fullWidth className="text-xs md:text-sm" data-id="element-279" data-mp="2ez0h22iqykon">
        QUIERO EL SISTEMA COMBO COMPLETO REHABILITACIÓN
      </Button>
    </article>;
}
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-280" data-mp="2nt51a33dkxv7">
      <div className="text-center" data-id="element-281" data-mp="2sqezo88qsjv6">
        <p className="text-[11px] font-bold uppercase tracking-[.16em] text-accent md:text-sm" data-id="element-282" data-mp="2stb146jstqod">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-283" data-mp="32qfno7hk3o5p">
          Asegurá el precio promocional <span className="text-accent" data-id="element-284" data-mp="36odc383i6681">antes de que suba.</span>
        </h2>
        <div className="mt-6" data-id="element-285" data-mp="18cwg04ttap6o">
          <Countdown data-id="element-286" data-mp="1ccoqwo6oh7f7" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-287" data-mp="1cdq3wy7983zk">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve', '72% de los cupos ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-288" data-mp="101ecnu3c2ka5">
                <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-289" data-mp="r329ytp6zw1c" />
                {item}
              </span>)}
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-lg" data-id="element-290" data-mp="1it6ssnxb0b0g">
        <PlanCard data-id="element-291" data-mp="1itgkqh1wss8s" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-slate-500" data-id="element-292" data-mp="1ir46advd100h">
        Pago 100% seguro · Acceso en 5 minutos · Mercado Pago hasta 12 cuotas
      </p>
    </section>;
}